<template>
  <div class="bottombox">
    <div class="cont">
      <img src="../../assets/img/bottom/tit.png"
           alt="">
      <div class="content">
        <div class="cont-l">
          <img src="../../assets/img/bottom/address.png"
               alt=""
               @click="showMap">
          <div class="contl-m">
            <div>
              <h4>联系方式</h4>
            </div>
            <ul>
              <li><img src="../../assets/img/bottom/icon1.png"
                     alt=""><span>合作电话</span>： 18913931035</li>
              <!-- <li><img src="../../assets/img/bottom/icon2.png"
                     alt="">南京市雨花台区云密城K栋12楼</li> -->
              <li><img src="../../assets/img/bottom/icon2.png"
                     alt=""><span>办公地址</span>： 南京市秦淮区永丰大道天安数码城4栋8楼</li>
              <li><img src="../../assets/img/bottom/icon3.png"
                     alt=""><span>电子邮箱</span>： yysmart@autof.cn</li>
              <li><img src="../../assets/img/bottom/icon1.png"
                     alt=""><span>售后电话</span>： 13357737768</li>
              <!-- <li><img src="../../assets/img/bottom/icon1.png"
                     alt=""><span>售后电话</span>： 13357737768 / 18951778401</li> -->
              <!-- <li><img src="../../assets/img/bottom/QQ.png"
                     alt=""><span>售后 Q Q</span>： 1327103441 / 1927103441</li> -->
            </ul>
          </div>
        </div>
        <div class="cont-r">
          <img src="../../assets/img/bottom/qrcode.jpg"
               alt="">
          <p>关注微信公众号</p>
        </div>
      </div>

    </div>
    <div style="background: #000; color: #fff; margin-top: 16px;">
      <p style="height: 50px; line-height:50px; text-align:center;">Copyright © 2019 南京药育智能科技有限公司 <a href="https://beian.miit.gov.cn" target="_blank" style="text-decoration: underline;">苏ICP备14010096号-2</a> 公安备案号 32011402010637</p>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      width="1080px"
      top="5vh"
      @close="dialogVisible=false">
      <img src="../../assets/img/bottom/address.png"
          height="609px"
          alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    showMap () {
      this.dialogVisible = true
    }
  },
}
</script>

<style lang="scss" scoped>
.bottombox {
  background: url(~@/assets/img/bottom/bg.png) top center;
  height: 610px;
  padding: 70px 0;
  .content {
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
    color: #fff;
    > div {
      background: rgba(191, 211, 242, 0.1);
      border-radius: 4px;
      padding: 20px;
      height: 280px;
    }
    .cont-l {
      display: flex;
      width: 920px;
      padding: 25px 20px;
      .contl-m {
        margin-left: 25px;
        div {
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          // margin-bottom: 60px;
          margin-bottom: 20px;
          h4 {
            font-size: 20px;
            color: $themeColor;
            // padding-bottom: 20px;
            padding-bottom: 10px;
            border-bottom: 2px solid $themeColor;
            display: inline-block;
          }
        }
        ul {
          li {
            font-size: 18px;
            // margin-bottom: 30px;
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            img {
              margin-right: 10px;
            }
          }
        }
      }
    }
    .cont-r {
      img {
        display: block;
        width: 200px;
      }
      p {
        text-align: center;
        margin-top: 20px;
      }
    }
  }
}
</style>